/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Event_TextInputs */

const en_bold_event_text = /** @type {(inputs: Bold_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bold event text`)
};

const fr_bold_event_text = /** @type {(inputs: Bold_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte d'événement en gras`)
};

const de_bold_event_text = /** @type {(inputs: Bold_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fettgedruckter Ereignistext`)
};

const it_bold_event_text = /** @type {(inputs: Bold_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo dell'evento in grassetto`)
};

const ru_bold_event_text = /** @type {(inputs: Bold_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жирным шрифтом выделен текст события`)
};

const es_bold_event_text = /** @type {(inputs: Bold_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto de evento en negrita`)
};

const zh_cn2_bold_event_text = /** @type {(inputs: Bold_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粗体事件文本`)
};

const ja_bold_event_text = /** @type {(inputs: Bold_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太字のイベントテキスト`)
};

const hi_bold_event_text = /** @type {(inputs: Bold_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बोल्ड इवेंट टेक्स्ट`)
};

const pt_pt2_bold_event_text = /** @type {(inputs: Bold_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto do evento em negrito`)
};

/**
* | output |
* | --- |
* | "Bold event text" |
*
* @param {Bold_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const bold_event_text = /** @type {((inputs?: Bold_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_bold_event_text(inputs)
	if (locale === "de") return de_bold_event_text(inputs)
	if (locale === "it") return it_bold_event_text(inputs)
	if (locale === "ru") return ru_bold_event_text(inputs)
	if (locale === "es") return es_bold_event_text(inputs)
	if (locale === "zh-CN") return zh_cn2_bold_event_text(inputs)
	if (locale === "ja") return ja_bold_event_text(inputs)
	if (locale === "hi") return hi_bold_event_text(inputs)
	if (locale === "pt-PT") return pt_pt2_bold_event_text(inputs)
	return en_bold_event_text(inputs)
});